export default class Aplicativo {
  constructor(descricao, recursos) {
    this.descricao = descricao;
    this.recursos = recursos;
  }
}